import { QRCodeCanvas } from 'qrcode.react'

/**
 * Always-on join corner for TV displays (owner rule 2026-08-11): the
 * room code, its QR, and the web address stay on the big screen
 * through EVERY phase, so a latecomer can join mid-game without
 * anyone touching the TV. Fixed to the bottom-right, inside typical
 * television overscan margins.
 */
export function TvJoinBadge({ code }: { code: string }) {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-4
                    bg-white/95 border border-brand-border rounded-2xl
                    shadow-card px-5 py-4">
      <QRCodeCanvas
        value={`https://games.jordandraper.com/join/${code}`}
        size={104} bgColor="#ffffff" fgColor="#111111"
      />
      <div>
        <p className="font-display text-3xl font-bold tracking-[0.2em] text-brand-text">
          {code}
        </p>
        <p className="text-sm text-brand-muted mt-1">games.jordandraper.com/join</p>
      </div>
    </div>
  )
}
